<template>
  <PanelV2
    type="w7"
    title="Grow your business with cashless payment acceptance!"
    @nextClick="next()"
  >
    <template v-slot:content-solt>
      <Digital @checkboxClick="checkboxClick" :digitalData="formData" />
    </template>
  </PanelV2>
</template>

<script>
import Digital from "./common/Digital.vue";
  import API from "@/api";

export default {
  name: "IndividualB",
  pRouter: "IndividualA",
  components: {
    Digital,
  },
  data() {
    return {
       formData: null,
       isSelected: true,
    };
  },
  methods: {
    checkboxClick(val) {
        this.formData = val
      },
      next() {
        if(this.formData.every(val => val.chooseFlag == '2')) {
          this.isSelected = false
        }
        const data = this.formatCommitData({digitalPaymentList: this.formData})

        API.addBdoProcess({
          ...data
        }).then(res => {
          if (res.success) {
            this.toNext({query: {isSelected: this.isSelected}})
          }
        })
      }
  },
};
</script>


<style lang="scss" scoped>
</style>
